<!-- HTML -->
<template>
  <div>

    <div
      class="jumbo-container"
      ref="jumboContainer"
    >
      <h1
        id="jumbo-text-1"
        class="jumbo-slider"
        ref="jumboSlider1"
      >
        Agressive.
      </h1>
      <h1
        id="jumbo-text-2"
        class="jumbo-slider"
        ref="jumboSlider2"
      >
        Analog.
      </h1>
      <h1
        id="jumbo-text-3"
        class="jumbo-slider"
        ref="jumboSlider3"
      >
        Industrial.
      </h1>
    </div>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "HomeJumboText",

  methods: {

    // Create Observer Function Constructor
    createObserver( myRoot, myRootMargin, myThreshold, myTarget, myTransitionDuration, myTransitionDelay ) { // Pass in options when called
     let observer;
     let options = {
       root: myRoot,
       rootMargin: myRootMargin,
       threshold: myThreshold
     };

     myTarget.style.transitionDuration = myTransitionDuration;
     myTarget.style.transitionDelay = myTransitionDelay;

     // Create a new IntersectionObserver with the constructor
     observer = new IntersectionObserver(this.handleIntersect, options);

     // Target HTML element that we will be watching is #box
     observer.observe(myTarget);

    },

    // Create Threshold List Function
    buildThresholdList( myNumSteps) {
      let thresholds = [];
      let numSteps = myNumSteps; // Number of steps
      for (let i=1.0; i<=numSteps; i++) {
        let ratio = i/numSteps;
        thresholds.push(ratio);
      }
      thresholds.push(0);
      return thresholds;
    },

    // Function that is run whenever the element is observed per the threshold
    // The callback function is automatically passed the intersectionObserverEntry object, which can be referenced with "entries"
    handleIntersect(entries) {

      let slideAmt;

      if (entries[0].intersectionRect.height === entries[0].intersectionRect.bottom && entries[0].isIntersecting === true) {
        slideAmt = 200 - (entries[0].intersectionRatio * 100);
        slideAmt = "translateX(-" + slideAmt + "vw)";
      } else {
        slideAmt = entries[0].intersectionRatio * 100;
        slideAmt = "translateX(-" + slideAmt + "vw)";
      }

      // Transform the slider
      this.$refs.jumboSlider1.style.transform = slideAmt;
      this.$refs.jumboSlider2.style.transform = slideAmt;
      this.$refs.jumboSlider3.style.transform = slideAmt;

    },

    // Create all the Intersection Observers
    createIntersectionObservers() {

      this.createObserver( null, '0px', this.buildThresholdList(200), this.$refs.jumboContainer, 0, 0 );

    }

  },

  mounted() {

    this.createIntersectionObservers();

  }

}



</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.jumbo-container {
  position: relative;
  margin: 0;
  height: 100vh;
  overflow: hidden;
}
.jumbo-slider {
  position: absolute;
  width: 100vw;
  height: 100vh;
  margin-top: 25vh;
  margin-bottom: 25vh;
}
#jumbo-text-1 {
  left: 100vw;
  // Height determined by Media Queries
}
#jumbo-text-2 {
  left: 120vw;
  top: 25vh;
  // Height determined by Media Queries
}
#jumbo-text-3 {
  left: 140vw;
  top: 50vh;
  // Height determined by Media Queries
}
h1 {
  white-space: nowrap;
  overflow: hidden;
  color: $white-trans-3;
  // Font Size determined by Media Queries
}
/* Media Queries */
@media screen and (max-width: 512px) {
  h1 {
    font-size: 10vh;
  }
}
@media all and (min-width: 513px) and (max-width: 640px) {
  h1 {
    font-size: 12vh;
  }
}
@media all and (min-width: 641px) and (max-width: 768px) {
  h1 {
    font-size: 14vh;
  }
}
@media all and (min-width: 769px) and (max-width: 896px) {
  h1 {
    font-size: 16vh;
  }
}
@media all and (min-width: 897px) and (max-width: 1024px) {
  h1 {
    font-size: 18vh;
  }
}
@media all and (min-width: 1025px) and (max-width: 1152px) {
  h1 {
    font-size: 20vh;
  }
}
@media all and (min-width: 1153px) and (max-width: 1280px) {
  h1 {
    font-size: 22vh;
  }
}
@media all and (min-width: 1281px) and (max-width: 1408px) {
  h1 {
    font-size: 24vh;
  }
}
@media all and (min-width: 1409px) {
  h1 {
    font-size: 26vh;
  }
}

</style>
